export default {
  data() {
    return {
      login: '',
      password: '',
      hidePw: true,
      isFormValid: false,
      loginRules: {
        password: v => (v.length && v.length > 5) || 'Укажите пароль',
        phone: v => (v.length && v.length >= 17) || 'Номер телефона заполнен не полностью',
      },
    };
  },
  computed: {
    loading() { return this.$store.state.loading; },
    phoneMask() {
      return this.login[0] === '8' ? '8 (###) ###-####' : '+7 (###) ###-####';
    },
  },
  methods: {
    Login() {
      const app = this;
      app.$store.getters.axl.post('profiles/api/login', { login: app.login, password: app.password })
        .then((response) => {
          app.$store.dispatch('UserLogin', response.data);
          app.$router.push('/dashboard');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
  },
};
